/**
 * Canonical path normalization for WebContainer FS + workbench store keys.
 * All tool adapters must use this helper.
 */
export function normalizeWorkbenchPath(filePath: string): string | null {
  const trimmed = filePath.trim().replace(/\\/g, '/').replace(/^\/+/, '');
  if (!trimmed) return null;
  const segments = trimmed.split('/').filter(Boolean);
  if (segments.some((s) => s === '..')) return null;
  return segments.join('/');
}

export function normalizeWorkbenchPathOrThrow(filePath: string): string {
  const normalized = normalizeWorkbenchPath(filePath);
  if (!normalized) {
    throw new Error(`Invalid path: ${filePath}`);
  }
  return normalized;
}
